import { FunctionComponent } from 'react'
import { getFromRegistry } from '../registry/utils'
import registry from '../registry/article'

const Child: FunctionComponent<{ data: any }> = ({ data }) => {
  const Component = getFromRegistry(registry, data?.kind)
  return <Component {...data} />
}

export default Child
